import { render, staticRenderFns } from "./customTableExpand.vue?vue&type=template&id=67314dc0"
import script from "./customTableExpand.vue?vue&type=script&lang=js"
export * from "./customTableExpand.vue?vue&type=script&lang=js"
import style0 from "./customTableExpand.vue?vue&type=style&index=0&id=67314dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports